import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import HeaderHeightState from "@tSurya/Store/Data/SurHeaderHeightState";
import { Draft } from "immer";

const initialState: HeaderHeightState = {
    headerHeight: 0,
};

const reducer = {
    "HomePage/SurHeader/SurHeaderHeight": (draft: Draft<HeaderHeightState>, action: { result: any }) => {
        draft.headerHeight = action.result;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
